import { useRef } from 'react';
import { useResourceObserver } from './resourceObserver';
import { applySelector, evictStaleSelectKeys, initial, normalizeResourceOptions, skipped } from './shared';

// Overload: param-less WITH select

// Overload: param-less WITHOUT select

// Overload: param-using WITH select

// Overload: param-using WITHOUT select

// Implementation
export function watch(resource, options) {
  const descriptor = Object.assign({
    resource: resource
  }, normalizeResourceOptions(options));
  if (options !== null && options !== void 0 && options.select) {
    descriptor.select = options.select;
  }
  return descriptor;
}
export const useResources = descriptors => {
  const selectCacheRef = useRef(new Map());
  // eslint-disable-next-line react-hooks/refs
  evictStaleSelectKeys(selectCacheRef.current, descriptors);
  return useResourceObserver(descriptors, (ctrl, {
    resource,
    params,
    instanceKey,
    skip,
    select
  }) => {
    var _ctrl$getState;
    if (skip) {
      return skipped;
    }
    const state = (_ctrl$getState = ctrl.getState({
      resource,
      params,
      instanceKey
    })) !== null && _ctrl$getState !== void 0 ? _ctrl$getState : initial;
    if (!select) {
      return state;
    }
    const cached = selectCacheRef.current.get(instanceKey);
    const result = applySelector(state, select, cached);
    selectCacheRef.current.set(instanceKey, {
      source: state,
      selector: select,
      result
    });
    return result;
  });
};